<template>
	<div class="row">
		<div class="col-xs-12">
			<div class="profile-picture">
				<div class="img-wrapper">
					<img :src="imgSrc" class="img-responsive">
				</div>
				<div class="file-browser">
					<input id="browser" type="file" @change="onLogoChange" accept="image/*">
					<button 
						id="browse" 
						type="button" 
						class="btn btn-sm btn-wireframe" 
						@click="browseFiles" 
						:disabled="isLoading">
						Change logo
					</button>
				</div>
			</div>
		</div>
		<div class="col-sm-5">
			<input-wrapper
				id="name"
				label="Your Name"
			>
				<input 
					id="name" 
					type="text" 
					class="form-control" 
					v-model="initialData.user.name"
					:disabled="isLoading"
				>
			</input-wrapper>
			<input-wrapper
				id="company_name"
				label="Company Name"
			>
				<input 
					id="company_name" 
					type="text" 
					class="form-control" 
					v-model="initialData.company.name"
					:disabled="isLoading"
				>
			</input-wrapper>
			<input-wrapper
				id="email_address"
				label="Email Address"
			>
				<input 
					id="email_address" 
					type="email" 
					class="form-control" 
					v-model="initialData.user.email"
					:disabled="isLoading"
				>
			</input-wrapper>
			<input-wrapper
				id="password"
				label="Password"
			>
				<input 
					id="password" 
					type="password" 
					class="form-control" 
					v-model="initialData.user.password"
					:disabled="isLoading"
					autocomplete="new-password"
				>
			</input-wrapper>
			<input-wrapper
				id="confirm_password"
				label="Confirm New Password"
			>
				<input 
					id="confirm_password" 
					type="password" 
					class="form-control" 
					v-model="initialData.user.password_confirmation"
					:disabled="isLoading"
				>
			</input-wrapper>
		</div>
		<!-- <div class="col-sm-7">
			<div>
				<label>Current Package</label>
			</div>
			<ul class="package-info">
				<li>
					<b>SMALL PACKAGE</b>
				</li>
				<li>
					<span>Valid Until 30 Dec 2019</span>
				</li>
				<li>
					<i class="fa fa-refresh"></i> <b>Auto Update Active</b>
				</li>
			</ul>
			<ul class="package-actions">
				<li>
					<button class="btn btn-link"><b>Upgrade to PRO</b></button>
				</li>
				<li>
					<button class="btn btn-link"><b>Payment Confirmation</b></button>
				</li>
			</ul>
			<div class="checkbox">
				<label>
					<input type="checkbox"> Yes, let me know about future update.
				</label>
			</div>
		</div> -->
	</div>
</template>

<script>
import { relativeUrl } from '../../helpers';
import InputWrapper from '../InputWrapper.vue';
import { defaultFields } from './helpers';

export default {
	props: {
		onLogoChange: {
			type: Function,
			required: true,
		},
		initialData: {
			type: Object,
			default: defaultFields,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		InputWrapper,
	},
	methods: {
		relativeUrl,
		browseFiles(e) {
			e.preventDefault();
			$('#browser').click();
		}
	},
	computed: {
		imgSrc() {
			if (this.initialData.company.logo === null) {
				return relativeUrl('/img/logo.png');
			}

			return this.initialData.company.logo;
		}
	}
}
</script>

<style lang="less" scoped>
.package-info,
.package-actions {
	display: flex;
	list-style: none;
	padding: 0;
}

.package-info {
	margin-top: 15px;
	justify-content: space-between;
}

.package-actions {
	justify-content: flex-start;
	margin-bottom: 30px;

	> li {
		margin-right: 30px;
	}
}

.profile-picture {
	display: flex;
	margin-bottom: 20px;

	.img-wrapper {
		margin-right: 20px;

		img {
			max-width: 100px;
			height: auto;
		}
	}

	.file-browser {
		#browser {
			width: 0px;
		}
	}
}
</style>
